import React from 'react';
import ReactECharts from 'echarts-for-react';

const GradeChart = () => {
  const option = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'axis', backgroundColor: '#15172b', borderColor: '#2a2d4f', textStyle: { color: '#f8fafc' } },
    grid: { top: 10, right: 10, bottom: 20, left: 30 },
    xAxis: {
      type: 'category',
      data: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5', 'Now'],
      axisLine: { lineStyle: { color: '#2a2d4f' } },
      axisLabel: { color: '#94a3b8', fontSize: 10 }
    },
    yAxis: {
      type: 'value',
      min: 70,
      max: 100,
      splitLine: { lineStyle: { color: '#2a2d4f', type: 'dashed' } },
      axisLabel: { color: '#94a3b8', fontSize: 10 }
    },
    series: [
      {
        data: [78, 82, 85, 84, 89, 92],
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: { color: '#eaff00' },
        lineStyle: { width: 3, shadowColor: 'rgba(234, 255, 0, 0.5)', shadowBlur: 10 },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(234, 255, 0, 0.3)' },
              { offset: 1, color: 'rgba(234, 255, 0, 0)' }
            ]
          }
        }
      }
    ]
  };

  return <ReactECharts option={option} className="h-full w-full" style={{ height: '100%', minHeight: '180px' }} />;
};

export default GradeChart;